module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/lizard_BW-p-500-d5a68d74761d299fa1b584601590b2a5.jpg";